// components/ui/close-button.tsx
interface CloseButtonProps {
  onClick: () => void;
  className?: string;
}

export function CloseButton({ onClick, className }: CloseButtonProps) {
  return (
    <button
      onClick={onClick}
      aria-label="Close"
      className={`
        p-1.5
        rounded-full
        text-red-400
        hover:bg-red-400
        hover:text-black
        transition
        focus:outline-none
        ${className ?? ""}
      `}
    >
      ✕
    </button>
  );
}
